import React, { Component } from 'react';
import { connect } from 'react-redux';

export default function(ComposedComponent) {
    class Loading extends Component {

        render(){
            return(
                <div>
                    {this.props.loading.loading ? <div className="loading"><i className="text-primary fa fa-5x fa-circle-o-notch fa-spin" /></div> : null}
                    <ComposedComponent {...this.props} />
                </div>
            )
        }

    }

    function mapStateToProps(state) {
        return { loading: state.loading };
    }

    return connect(mapStateToProps)(Loading);
}




// WEBPACK FOOTER //
// ./resources/assets/js/components/common/Loading.jsx